interface SpinnerProps {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function Spinner({ label = 'Carregando…', size = 'md' }: SpinnerProps) {
  return (
    <span className={`spinner spinner--${size}`} role="status" aria-live="polite">
      <span className="spinner__circle" aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </span>
  );
}

export function PageSpinner({ label = 'Carregando…' }: { label?: string }) {
  return (
    <div className="page-spinner">
      <Spinner size="lg" label={label} />
    </div>
  );
}
